export default "__VITE_PUBLIC_ASSET__24f3bc91__"